import { SpringConfigsType } from 'interfaces/generic';

type TFrConfigs = Required<
  Pick<
    SpringConfigsType,
    | 'ACCOUNT_CLOSURE'
    | 'SHOW_INFO_POPUP_BEFORE_REASONS_IN_ACCOUNT_CLOSE'
    | 'SHOW_WITHDRAWAL_CHECKER_MODAL'
    | 'HIDE_WAGERING_FACTOR'
    | 'SHOW_ACCOUNT_VERIFICATION_SECTION'
    | 'IS_PREDEFINED_PAYMENT_METHODS_AVAILABLE'
    | 'SHOW_BANK_NAME_IN_PAYMENT'
    | 'SHOW_TIMEOUT_INFO'
    | 'IS_FAST_REGISTRATION_ENABLED'
    | 'SHOW_CONFIRMATION_POPUP_FOR_LIMITS'
    | 'LOGIN_FREEZE'
  >
>;

export default {
  ACCOUNT_CLOSURE: true,
  SHOW_INFO_POPUP_BEFORE_REASONS_IN_ACCOUNT_CLOSE: true,
  SHOW_WITHDRAWAL_CHECKER_MODAL: true,
  HIDE_WAGERING_FACTOR: true,
  SHOW_ACCOUNT_VERIFICATION_SECTION: true,
  IS_PREDEFINED_PAYMENT_METHODS_AVAILABLE: true,
  SHOW_BANK_NAME_IN_PAYMENT: true,
  SHOW_TIMEOUT_INFO: true,
  IS_FAST_REGISTRATION_ENABLED: true,
  SHOW_CONFIRMATION_POPUP_FOR_LIMITS: true,
  LOGIN_FREEZE: true
} as TFrConfigs;
